import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { AvatarComponent } from '../avatar/avatar.component';
import { HighlightPipe } from '../../pipes/highlight.pipe';
import { CommonModule } from '@angular/common';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-user-info',
  imports: [CommonModule, MatIcon, AvatarComponent, HighlightPipe],
  template: `
    <div class="user-info">
      @if (!iconAvatar()) {
      <app-avatar [userName]="userName()" class="avatar"></app-avatar>
      } @else {
      <div class="pending-avatar avatar">
        <mat-icon [class]="iconAvatarClass()"> mark_email_unread </mat-icon>
      </div>
      }

      <div class="user-details">
        <div
          class="user-name"
          [innerHTML]="userName() | highlight : searchQuery() ?? ''"
        ></div>
        @if (userEmail()) {
        <div
          class="user-email"
          [innerHTML]="userEmail() | highlight : searchQuery() ?? ''"
        ></div>
        }
      </div>
    </div>
  `,
  styles: `
      @use "spacing/spacing-variables" as *;
      @use "mixins/mixins" as *;

      .user-info {
        width: 100%;
        display: grid;
        grid-template-columns: $spacing-3xl 1fr;
        grid-template-rows: auto;
        column-gap: $spacing-lg;
        align-items: center;

        .avatar {
          @include flex-center;
          justify-content: center;
          border-radius: 100%;
        }

        .user-details {
          display: flex;
          flex-direction: column;
          justify-content: center;
        }

        .user-avatar {
          font-size: 16px;
          font-style: normal;
          font-weight: 500;
          background-color: var(--mat-sys-primary-container);
        }

        .user-name {
          font-size: 16px;
          font-weight: 500;
          color: var(--mat-sys-on-sufrace);
          margin-bottom: $spacing-2xs;
        }

        .user-email {
          font-size: 12px;
          font-weight: 400;
          color: var(--mat-sys-on-surface-variant);
        }
      }
    `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserInfoComponent {
  userName = input.required<string>();
  userEmail = input<string>();
  iconAvatar = input<string>();
  iconAvatarClass = input<string>();
  searchQuery = input<string>();
}
